import { FolderPlus, Trash2, X } from "lucide-react";

/*
 * References / Select bar: one floating bar at the foot of the wall. The count,
 * then Collect and Delete. The X clears the selection.
 */
export default function ReferenceSelectBar({
  count,
  canEdit,
  canDelete,
  onCollect,
  onDelete,
  onClear,
}: {
  count: number;
  canEdit: boolean;
  canDelete: boolean;
  onCollect: (anchor: HTMLElement) => void;
  onDelete: () => void;
  onClear: () => void;
}) {
  const none = count === 0;
  return (
    <div className="ref-select-bar" role="toolbar" aria-label="Selected references">
      <span className="ref-mono font-semibold text-co-text" aria-live="polite">
        {count} selected
      </span>
      <span className="h-5 w-px bg-co-line2" aria-hidden />
      {canEdit ? (
        <button type="button" className="ref-bar-btn ref-bar-btn--primary" disabled={none} onClick={(e) => onCollect(e.currentTarget)}>
          <FolderPlus aria-hidden className="size-[13px]" />
          Collect
        </button>
      ) : null}
      {canEdit ? (
        <button type="button" className="ref-bar-btn ref-bar-btn--danger" disabled={none || !canDelete} onClick={onDelete}>
          <Trash2 aria-hidden className="size-[13px]" />
          Delete
        </button>
      ) : null}
      <button type="button" className="grid size-[34px] place-items-center rounded-full text-co-text2 hover:bg-co-hover" aria-label="Stop selecting" onClick={onClear}>
        <X aria-hidden className="size-3.5" />
      </button>
    </div>
  );
}
